import { CloseOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import { useMemo, useState } from 'react';

import type { NAttachFilesForClientCardComponent } from '@app/components/AttachFilesForClientCardComponent/AttachFilesForClientCardComponent.types';
import { DraggerComponent } from '@app/components/DraggerComponent';
import { MAX_FILES_SIZE } from '@app/components/DraggerComponent/data/constants';
import { CANCEL, PREFIX } from '@app/constants';

export const AttachFilesForClientCardComponent: NAttachFilesForClientCardComponent.Main =
  ({
    filesModal,
    handleFilesOk,
    handleFilesCancel,
    filesModalIsLoading,
    data,
    filesWithData,
    setFilesWithData,
    isChatFilesComponent,
  }) => {
    const [disabled, setDisabled] = useState(false);
    const totalSize = useMemo(
      () => filesWithData.reduce((acc, file) => acc + (file?.Size || 0), 0),
      [filesWithData]
    );

    const isFilesSizeExceeded = useMemo(
      () => totalSize > MAX_FILES_SIZE,
      [totalSize]
    );

    return (
      <Modal
        data-testid="upload-files"
        title={
          <span data-testid="upload-files-title">Загрузить фото и файлы</span>
        }
        closeIcon={<CloseOutlined data-testid="close-popup" />}
        open={filesModal}
        onOk={handleFilesOk}
        onCancel={() => {
          setFilesWithData([]);
          handleFilesCancel();
        }}
        cancelText={<span data-testid="cancel">{CANCEL}</span>}
        okText={
          <span data-testid="save">
            {isChatFilesComponent ? 'Отправить' : 'Сохранить'}
          </span>
        }
        okButtonProps={{
          type: 'primary',
          loading: filesModalIsLoading,
          disabled: isFilesSizeExceeded || disabled,
        }}
        cancelButtonProps={{
          disabled: filesModalIsLoading || isFilesSizeExceeded || disabled,
        }}
        className={`${PREFIX}files-modal`}
      >
        <DraggerComponent
          isChat={isChatFilesComponent}
          isFilesSizeExceeded={isFilesSizeExceeded}
          id={data?.Id}
          setFilesWithData={setFilesWithData}
          filesWithData={filesWithData}
          totalSize={totalSize}
          onLoadStart={() => setDisabled(true)}
          onLoadEnd={() => setDisabled(false)}
          isLoading={filesModalIsLoading}
          extraExtensions={['mp3']}
        />
      </Modal>
    );
  };
